import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Report from "../../../models/Report";
import formatNumberAsPrice from "../../../utilities/formatNumberAsPrice";
import DataTable from "../dataTable";

const initialTable = {
    page: 1,
    term: "",
    sort: "totalRevenue",
    order: "asc",
    limit: 25,
};

export default function GolfClubTeeTimeRevenue() {
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState(initialTable);
    const [totalRecords, setTotalRecords] = useState(0);
    const [data, setData] = useState([]);

    const getData = useCallback(async (params) => {
        setLoading(true);
        const response = await Report.golfClubTeeTimeRevenue(params);
        setData(response.items);
        setTotalRecords(response.total);
        setTable(params);
        setLoading(false);
    }, []);

    useEffect(() => {
        getData(initialTable);
    }, [getData]);

    const headers = [
        { key: "golfClub", text: "Golf club" },
        { key: "completedBookings", text: "Completed tee-time bookings" },
        { key: "totalRevenue", text: "Total revenue" },
    ];
    const tableData = data.map((item) => {
        const totalRevenue = Number(item.totalRevenue || 0);
        return {
            golfClub: {
                value: (
                    <Link to={`/golf-clubs/${item._id}`}>{item.name}</Link>
                ),
                search: item.name,
            },
            completedBookings: {
                value: item.completedBookings,
                search: item.completedBookings,
            },
            totalRevenue: {
                value: `£ ${formatNumberAsPrice(totalRevenue)}`,
                search: totalRevenue,
            },
        };
    });

    return (
        <>
            <h4>Golf club tee-time revenue</h4>
            <p>
                Total all-time member spend from completed tee-time bookings by
                golf club.
            </p>
            <DataTable
                loading={loading}
                headers={headers}
                data={tableData}
                totalRecords={totalRecords}
                page={table.page}
                onChange={getData}
                searchTerm={table.term}
                sort={table.sort}
                order={table.order}
                limit={table.limit}
                sortOptions={[
                    { text: "Total revenue", key: "totalRevenue" },
                    { text: "Golf club", key: "name" },
                    {
                        text: "Completed tee-time bookings",
                        key: "completedBookings",
                    },
                ]}
                pagination
            />
        </>
    );
}
